export default "__VITE_ASSET__37716e31__"